// 快速任务
export default {
    taskSettings: '任务设置',
    targetPointEdit: '目标点编辑',
    target: '目标点',
    performTasks: '执行任务',
    taskPaused: '任务暂停',
    taskContinues: '任务继续',
    returnImmediately: '立即返航',
    landImmediately: '立即降落',
    pleaseSelectGroup: '请选择组',
    pleaseSelectTargetPoint: '请选择目标点',
    latestTarget: '最新目标点',
    pleaseEnterNote: '请输入备注',
    add: '添加',
    groupSettings: '分组设置',
    groupName: '分组名',
    enterUAVname: '请输入无人机名字',
    optionalUAV: '可选无人机',
    selectedUAV: '已选无人机',
    flightParameters: '飞行参数',
    trajectory: '弹道',
    trajectoryOne: '弹道一',
    trajectoryTwo: '弹道二',
    trajectoryThree: '弹道三',
    takeoffAltitude: '起飞高度',
    maxAltitude: '最大高度',
    speed: '速度',
    acceleration: '加速度',
    endAction: '结束动作',
    landing: '降落',
    returnFlight: '返航',
    homing: '归航',
    refresh: '刷新',
    mapPickup: '地图拾取',
    endPickup: '结束拾取',
    obtain: '获取',
    tip_CBEO: '不能为空或0',
    tip_PEANV: '请输入数字值',
    tip_WVR: '数值范围错误',
    tip_TAMB: '起飞高度必须小于最大高度',
    tip_PTODP: '精度为一位小数',
    tip_wrongFormat: '格式错误',
    tip_HCBE: '高度不能为空',
    tip_HMBA: '高度必须为数字值',
}